import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
} from "react-bootstrap";
import axiosInstance from '../../services/AxiosInstance';
import { Link } from 'react-router-dom';
import './commonstyle.css';
import InternalFooter from '../components/InternalFooter/InternalFooter';
import CommonTable from '../components/CommonTable/CommonTable';
import '../tasks/tasklist.css';

const DesignationList = () => {
  const navigate = useNavigate();
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDesignations, setfilteredDesignations] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDesignation, setselectedDesignation] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const notifyTopRight = (data) => {
    toast.success(`✔️ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const notifyError = (data) => {
    toast.error(`❌ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    fetchDesignations();
  }, []);

  useEffect(() => {
    // Filter designation based on search term
    if (searchTerm.trim() === '') {
      setfilteredDesignations(designations);
    } else {
      const filtered = designations.filter(designation =>
        designation.name.toLowerCase().includes(searchTerm.toLowerCase())         
      );
      setfilteredDesignations(filtered);
    }
  }, [designations, searchTerm]);

  const fetchDesignations = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      const res = await axiosInstance.get(`/settings/getDesignationList?corporate_id=${corporateId}`);
      const data = res.data;
      
      if (res) {
        setDesignations(data.data || data || []);
      }
    } catch (error) {
      console.error("Designation list fetch error:", error);
      notifyError('Failed to fetch designations');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedDesignation) return;
    const userData = JSON.parse(localStorage.getItem('user'));
    setDeleteLoading(true);
    try {
      const res = await axiosInstance.put(`/settings/deactivateBranch`, { branch_id: selectedDesignation.id, updated_by: userData.id });
      
      if (res) {
        notifyTopRight('Designation deleted successfully');
        fetchDesignations(); // Refresh the list
        setShowDeleteModal(false);
        setselectedDesignation(null);
      }
    } catch (error) {
      console.error('Delete designation error:', error);
      if (error.status === 409) {
        notifyError('Cannot delete designation with staff');
      } else {
        notifyError(error.response?.data?.error || 'Failed to delete designation');
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleEdit = (designation) => {
    navigate(`/settings/editDesignation/${designation.id}`, { state: { designation } });
  };

  // Define columns for CommonTable
  const columns = [
    {
      key: 'index',
      header: '#',
      accessor: (row, index) => index + 1,
    },
    {
      key: 'name',
      header: 'Designation',
      accessor: 'name',
    },
  ];

  // Define actions for CommonTable
  const getActions = (row, rowIndex) => {
    return [
      {
        label: 'Edit',
        icon: 'fas fa-edit',
        onClick: () => handleEdit(row),
      },
      {
        label: 'Delete',
        icon: 'fas fa-trash',
        className: 'text-danger',
        onClick: () => {
          setselectedDesignation(row);
          setShowDeleteModal(true);
        },
      },
    ];
  };

  return (
    <Row style={{marginBottom: "0px !important"}}>
      <ToastContainer />
      <Col lg={12}>
        <Card className="user-list-card">
          <Card.Header style={{ display: 'block' }}>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div className="search-input-group">
                <i className="fas fa-search search-icon"></i>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search designations..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="d-flex align-items-center gap-2">
                <Link to='/settings/addDesignation' className="new-user-btn">
                  <i className="fas fa-plus me-2"></i>
                  Add Designation
                </Link>
              </div>
            </div>
          </Card.Header>
          <Card.Body style={{ minHeight: '400px', overflow: 'visible', padding: '1.5rem' }}>
            {loading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
              </div>
            ) : (
              <div className="row">
                <CommonTable
                  columns={columns}
                  data={filteredDesignations}
                  actions={getActions}
                  emptyMessage={designations.length === 0 ? 'No designations found' : 'No designations match your search criteria'}
                  emptyStateIcon="fas fa-briefcase"
                  getRowId={(row, index) => row.id || index}
                  maxHeight="70vh"
                  minHeight="400px"
                />
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the designation "{selectedDesignation?.name}"? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button 
            variant="danger" 
            onClick={handleDelete}
            disabled={deleteLoading}
          >
            {deleteLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <InternalFooter />
    </Row>
  );
};

export default DesignationList;
